<script>
  import IconsInfo from '$lib/components/icons/IconsInfo.svelte';

  let expanded = false;
</script>

<button
  class="relative h-5 w-5 hover:cursor-default"
  on:mouseenter={() => (expanded = true)}
  on:mouseleave={() => (expanded = false)}
  on:click={() => (expanded = !expanded)}
>
  {#if expanded}
    <div
      class="absolute bottom-full left-1/2 mb-1 w-64 -translate-x-1/2 transform whitespace-nowrap text-wrap rounded bg-gray-700 px-2 py-1 text-xs text-white text-left"
    >
      <p>
        <slot />
      </p>
    </div>
  {/if}
  <IconsInfo class="h-5 w-5" />
</button>
